export default class AbstractMethodError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'AbstractMethodError';
  }
}
